var React = require('react');

function IndexContactImgMailBadge (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"IndexContact__img__mail-badge","fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},[React.createElement("path",{"id":"Fill-11","fill":"#CF000E","d":"M87.319,43.659 C87.319,67.771 67.771,87.318 43.659,87.318 C19.547,87.318 -2.55795385e-13,67.771 -2.55795385e-13,43.659 C-2.55795385e-13,19.547 19.547,0 43.659,0 C67.771,0 87.319,19.547 87.319,43.659","key":0}),React.createElement("polygon",{"id":"1","fill":"#FFF","fillRule":"nonzero","points":"49.053 64.048 49.053 18.767 46.417 18.767 34.986 22.402 34.986 31.78 40.063 30.309 40.063 64.048","key":1})]));
}

IndexContactImgMailBadge.defaultProps = {"width":"88","height":"88","viewBox":"0 0 88 88"};

module.exports = IndexContactImgMailBadge;

IndexContactImgMailBadge.default = IndexContactImgMailBadge;
